import React, {FunctionComponent, useCallback, useContext} from 'react';
import './SectionPreloader.scss';
import styled from "styled-components";
import {ThemeContext} from "../../context/ThemeContext";
import {Theme} from "../../models/theme.model";

const StyledSectionPreloader = styled.i`
    &&& {
      text-align: center;
      border-color: ${props => props.theme.branding_color};
      border-bottom-color: ${props => props.theme.branding_light_color};
    }
`;

interface SectionPreloaderProps {
    size?: string;
}

export const SectionPreloader: FunctionComponent<SectionPreloaderProps> = (props) => {
    const theme: Theme = useContext(ThemeContext).theme;

    const getClassNames = useCallback(()=>{
        const classes = ['section-preloader'];
        if(props.size) {
            classes.push(props.size);
        }
        return classes.join(' ');
    }, [props.size]);

    return (
        <div className={getClassNames()}>
            <StyledSectionPreloader theme={theme} className="circle-preloader"/>
        </div>
    );
};
